import FullPageWrapper from 'global/wrappers/FullPageWrapper';
import ItemMenuSquares from 'global/wrappers/ItemMenuSquares ';
import Wrapper from 'global/wrappers/Wrapper';
import { useContext, useMemo, useState } from 'react';
import { Icon, Label } from 'semantic-ui-react';
import { SeasonMatchesContext } from '../../cnr/contexts/SeasonMatchesContext';
import { SportsMatchContext } from '../../cnr/contexts/SportsMatchContext';
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext';
import { _matchResultTypes, matchDisplayTypes } from '../../cnr/reducers/SportsMatchReducer';
import { sportsShowTypes } from '../../cnr/reducers/SportsSeasonReducer';
import MatchScoreButtons from './MatchScoreButtons';
import { CreateMatchResult_withProvider } from 'projectSpecific/sports/create/CreateMatchResult';
import { MatchResultSquares } from './MatchResultSquares';

const _matchOptionTypes = {
  realtimeScoring: 'realtimeScoring',
  updateResults: 'updateResults',
}

const MatchOptions = (props) => {

  // seasonMatchesContext
  const seasonMatchesContext = useContext(SeasonMatchesContext)
  const { seasonMatches_state, seasonMatches_handlers } = seasonMatchesContext ?? {}
  const { matchScheduleType, matchDisplayType } = seasonMatches_state ?? {}

  // sportsMatchContext
  const sportsMatchContext = useContext(SportsMatchContext)
  const { sportsMatch_state } = sportsMatchContext ?? {}
  const { match_true } = sportsMatch_state ?? {}
  const { _resultsStatus } = match_true ?? {}
  const { scoreType } = _resultsStatus ?? {}
  const { away, home } = match_true ?? {}

  const [showResults, setShowResults] = useState()

  let allowRtScoring = true;

  switch (scoreType) {
    case _matchResultTypes.matchDay:
      allowRtScoring = false
      break;
    default:
    // nothingFv
  }

  // const handleShow_matchScoreTable = (e) => {
  //   e && e.stopPropagation()
  //   const opts = { sportsShowType: sportsShowTypes.updateResults, matchKey: match_true?._itemKey }
  //   setShowResults(!showResults)
  //   // sportsSeason_handlers.handleShow_sportsElem(opts)
  // }

  // const handleShow_matchRtScoring = (e) => {
  //   e && e.stopPropagation()
  //   seasonMatches_handlers && seasonMatches_handlers.handleSelect_currentMatch(match_true, matchDisplayTypes.realtimeScoring)
  // }

  // const handleOptionClick = (item) => {
  //   switch (item) {
  //     case _matchOptionTypes.realtimeScoring:
  //       return handleShow_matchRtScoring()
  //     case _matchOptionTypes.updateResults:
  //       return handleShow_matchScoreTable()
  //   }
  // }

  // const match_options = useMemo(() => { return <ItemMenuSquares menuItems={_matchOptionTypes} onClick={handleOptionClick} /> }, [])

  // const content_teams = useMemo(() => {
  //   return <div className='match-score-teams'>
  //     <div>{away?.name}</div>
  //     <div>{home?.name}</div>
  //   </div>
  // }, [away, home])

  // const content_match = (content) => {
  //   return <div className='match-score-content opts'>
  //     {content_teams}
  //     {content}
  //   </div>
  // }


  return <MatchResultSquares match_true={match_true} />

}

export default MatchOptions